export default "__VITE_ASSET__BpISixg4__"